import { render, staticRenderFns } from "./AMfaOptions.vue?vue&type=template&id=2328b8bc&"
import script from "./AMfaOptions.vue?vue&type=script&lang=js&"
export * from "./AMfaOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports